var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "rb-panel",
    {
      staticClass: "rb-eyewear-protection-panel",
      attrs: { visible: _vm.isVisible },
      on: { closed: _vm.closePanel },
    },
    [_c("rb-eyewear-protection-overlay-content")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }